/*
 * faq-loader.js — FAQ page driven by a published Google Sheet CSV (Shwink D5, Rev 2).
 *
 * Fetches the CSV (URL from the "FAQ Google Sheet CSV URL" theme setting), parses
 * it with PapaParse, and renders: category card grid → MFAQ (Featured rows) →
 * full categorised <details> sections. A search box filters across
 * Question + Answer + Keywords. Answers are Markdown, rendered via a tiny
 * escape-first subset parser (XSS-safe by construction — no external sanitizer).
 *
 * CSV columns: Category, Question, Answer, Keywords.
 * Keywords is a comma-separated token list: token "Featured" promotes the row
 * into the MFAQ block; all other tokens are extra search terms.
 */
(function () {
  'use strict';

  var CARET =
    '<svg viewBox="0 0 10 6" class="icon icon-caret" aria-hidden="true" focusable="false">' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>';

  /* ---------------- category icons (inline Feather-style SVG, aria-hidden) ---------------- */
  function svg(inner) {
    return '<svg class="faq2-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + inner + '</svg>';
  }
  var ICONS = {
    info: svg('<circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/>'),
    droplet: svg('<path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"/>'),
    shirt: svg('<path d="M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z"/>'),
    leaf: svg('<path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"/><path d="M2 21c0-3 1.85-5.36 5.08-6"/>'),
    box: svg('<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/>'),
    card: svg('<rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/>'),
    truck: svg('<rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>'),
    alert: svg('<circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>'),
    rotate: svg('<polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/>'),
    settings: svg('<circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>'),
    help: svg('<circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/>'),
    list: svg('<line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/>')
  };
  function iconFor(cat) {
    var c = cat.toLowerCase();
    if (c.indexOf('about') >= 0) return ICONS.info;
    if (c.indexOf('how to use') >= 0 || c.indexOf('use shwink') >= 0) return ICONS.droplet;
    if (c.indexOf('fabric') >= 0) return ICONS.shirt;
    if (c.indexOf('ingredient') >= 0 || c.indexOf('safety') >= 0) return ICONS.leaf;
    if (c.indexOf('product') >= 0 || c.indexOf('stock') >= 0) return ICONS.box;
    if (c.indexOf('payment') >= 0) return ICONS.card;
    if (c.indexOf('shipping') >= 0 || c.indexOf('packaging') >= 0 || c.indexOf('delivery') >= 0) return ICONS.truck;
    if (c.indexOf('order') >= 0) return ICONS.alert;
    if (c.indexOf('return') >= 0 || c.indexOf('refund') >= 0) return ICONS.rotate;
    if (c.indexOf('technical') >= 0) return ICONS.settings;
    return ICONS.help;
  }

  /* ---------------- Markdown (safe subset) ---------------- */
  function escapeHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function escapeAttr(s) { return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;'); }
  function safeHref(url) {
    var u = (url || '').trim();
    var lower = u.toLowerCase();
    if (lower.indexOf('&#') >= 0 || /[ - <>"'`\\]/.test(u)) return null;
    if (/^(https?:\/\/|mailto:|tel:)/.test(lower)) return u;
    if (/^[/#]/.test(u) || /^\.{1,2}\//.test(u)) return u;
    if (/^[^\s:@]+@[^\s:@]+\.[^\s:@]+$/.test(u)) return 'mailto:' + u;
    return null;
  }
  function renderBlock(block) {
    var lines = block.split('\n');
    var nonEmpty = lines.filter(function (l) { return l.trim() !== ''; });
    var isUL = nonEmpty.length && nonEmpty.every(function (l) { return /^\s*[-*]\s+/.test(l); });
    var isOL = nonEmpty.length && nonEmpty.every(function (l) { return /^\s*\d+\.\s+/.test(l); });
    if (isUL || isOL) {
      var items = nonEmpty.map(function (l) { return '<li>' + l.replace(/^\s*(?:[-*]|\d+\.)\s+/, '') + '</li>'; }).join('');
      return isOL ? '<ol>' + items + '</ol>' : '<ul>' + items + '</ul>';
    }
    return '<p>' + block.replace(/\n/g, '<br>') + '</p>';
  }
  function mdToHtml(md) {
    var links = [];
    var stripped = String(md).replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, function (_, text, url) {
      links.push({ text: text, href: safeHref(url) });
      return ' L' + (links.length - 1) + ' ';
    });
    var esc = escapeHtml(stripped)
      .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
      .replace(/__([^_]+)__/g, '<strong>$1</strong>')
      .replace(/\*([^*]+)\*/g, '<em>$1</em>')
      .replace(/(^|[^\w])_([^_]+)_(?=[^\w]|$)/g, '$1<em>$2</em>');
    var html = esc.split(/\n{2,}/).map(renderBlock).join('');
    return html.replace(/ L(\d+) /g, function (_, i) {
      var l = links[+i];
      var label = escapeHtml(l.text);
      if (!l.href) return label;
      var external = /^https?:\/\//i.test(l.href) && l.href.toLowerCase().indexOf('shwink') === -1;
      return '<a href="' + escapeAttr(l.href) + '"' + (external ? ' target="_blank" rel="noopener noreferrer"' : '') + '>' + label + '</a>';
    });
  }

  /* ---------------- helpers ---------------- */
  function slugify(s) { return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function leadingInt(s) { var m = s.match(/^\s*(\d+)/); return m ? parseInt(m[1], 10) : 9999; }
  function el(tag, cls) { var e = document.createElement(tag); if (cls) e.className = cls; return e; }

  function accordion(question, answerHtml) {
    var wrap = el('div', 'accordion faq2-accordion');
    var det = document.createElement('details');
    var sum = document.createElement('summary');
    var title = el('span', 'accordion__title h5');
    title.textContent = question;
    sum.appendChild(title);
    sum.insertAdjacentHTML('beforeend', CARET);
    var content = el('div', 'accordion__content rte');
    content.setAttribute('role', 'region');
    content.innerHTML = answerHtml;
    det.appendChild(sum); det.appendChild(content);
    wrap.appendChild(det);
    return wrap;
  }

  /* ---------------- build model from parsed rows ---------------- */
  function buildModel(rows) {
    var cats = {}, order = [], featured = [], all = [];
    rows.forEach(function (r, idx) {
      var category = (r.Category || '').trim();
      var question = (r.Question || '').trim();
      var answer = (r.Answer || '').trim();
      if (!category || !question || !answer) {
        console.warn('[faq-loader] skipping row ' + idx + ' — missing Category/Question/Answer');
        return;
      }
      var tokens = (r.Keywords || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
      var isFeatured = tokens.some(function (t) { return t.toLowerCase() === 'featured'; });
      var searchKeywords = tokens.filter(function (t) { return t.toLowerCase() !== 'featured'; });
      var item = {
        category: category,
        question: question,
        answerHtml: mdToHtml(answer),
        searchText: (question + ' ' + answer + ' ' + searchKeywords.join(' ')).toLowerCase(),
        idx: idx
      };
      all.push(item);
      if (isFeatured) featured.push(item);
      if (!cats[category]) { cats[category] = { name: category, slug: 'faq-cat-' + slugify(category), rows: [] }; order.push(category); }
      cats[category].rows.push(item);
    });
    order.sort(function (a, b) {
      var d = leadingInt(a) - leadingInt(b);
      return d !== 0 ? d : a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
    });
    return { categories: order.map(function (n) { return cats[n]; }), featured: featured, all: all };
  }

  /* ---------------- rendering ---------------- */
  function buildSection(cat) {
    var sec = el('div', 'faq2-category');
    sec.id = cat.slug;
    var h2 = el('h2', 'faq2-category__title h4');
    h2.innerHTML = '<span class="faq2-category__icon">' + iconFor(cat.name) + '</span>' + escapeHtml(cat.name.replace(/^\s*\d+\.\s*/, ''));
    sec.appendChild(h2);
    cat.rows.forEach(function (r) { sec.appendChild(accordion(r.question, r.answerHtml)); });
    return sec;
  }

  function render(root, model) {
    var cardsEl = root.querySelector('[data-faq-cards]');
    var mfaqEl = root.querySelector('[data-faq-mfaq]');
    var panelEl = root.querySelector('[data-faq-sections]'); // expand-below panel
    var activeKey = null;

    function fillPanel(key) {
      panelEl.innerHTML = '';
      if (key === 'all') {
        model.categories.forEach(function (c) { panelEl.appendChild(buildSection(c)); });
      } else {
        for (var i = 0; i < model.categories.length; i++) {
          if (model.categories[i].slug === key) { panelEl.appendChild(buildSection(model.categories[i])); break; }
        }
      }
      // "All" leaves questions collapsed (long); a single category opens its questions.
      if (key !== 'all') {
        var dets = panelEl.querySelectorAll('details');
        for (var d = 0; d < dets.length; d++) dets[d].open = true;
      }
      panelEl.hidden = false;
    }

    function setActiveCard(key) {
      var all = cardsEl.querySelectorAll('.faq2-card');
      for (var i = 0; i < all.length; i++) {
        all[i].classList.toggle('faq2-card--active', all[i].getAttribute('data-key') === key);
      }
    }

    function select(key) {
      if (activeKey === key) { // toggle off
        activeKey = null; panelEl.hidden = true; panelEl.innerHTML = '';
        setActiveCard(null); return;
      }
      activeKey = key; fillPanel(key); setActiveCard(key);
      panelEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    function makeCard(key, iconSvg, label, countText) {
      var card = el('button', 'faq2-card');
      card.type = 'button';
      card.setAttribute('data-key', key);
      card.innerHTML =
        '<span class="faq2-card__icon">' + iconSvg + '</span>' +
        '<span class="faq2-card__label">' + escapeHtml(label) + '</span>' +
        '<span class="faq2-card__count">' + countText + '</span>';
      card.addEventListener('click', function () { select(key); });
      return card;
    }

    // Card grid: "All Questions" first, then one card per category.
    cardsEl.innerHTML = '';
    cardsEl.appendChild(makeCard('all', ICONS.list, 'All Questions', model.all.length + ' questions'));
    model.categories.forEach(function (cat) {
      cardsEl.appendChild(makeCard(cat.slug, iconFor(cat.name), cat.name.replace(/^\s*\d+\.\s*/, ''),
        cat.rows.length + (cat.rows.length === 1 ? ' question' : ' questions')));
    });
    cardsEl.hidden = false;

    // MFAQ (Featured) — hidden if none
    if (model.featured.length) {
      mfaqEl.innerHTML = '<h2 class="faq2__mfaq-title h4">Most Frequently Asked</h2>';
      var list = el('div', 'faq2__mfaq-list');
      model.featured.forEach(function (r) { list.appendChild(accordion(r.question, r.answerHtml)); });
      mfaqEl.appendChild(list);
      mfaqEl.hidden = false;
    } else {
      mfaqEl.hidden = true;
    }

    // Panel starts empty — a category expands into it on click.
    panelEl.innerHTML = '';
    panelEl.hidden = true;
  }

  /* ---------------- search ---------------- */
  function wireSearch(root, model, input) {
    if (!input) return;
    var resultsEl = root.querySelector('[data-faq-results]');
    var cardsEl = root.querySelector('[data-faq-cards]');
    var mfaqEl = root.querySelector('[data-faq-mfaq]');
    var sectionsEl = root.querySelector('[data-faq-sections]');
    var contactUrl = root.getAttribute('data-contact-url') || '/pages/contact';
    var mfaqHadContent = model.featured.length > 0;

    function showBrowse() {
      resultsEl.hidden = true; resultsEl.innerHTML = '';
      cardsEl.hidden = false;
      sectionsEl.hidden = sectionsEl.children.length === 0; // panel only if a category is expanded
      mfaqEl.hidden = !mfaqHadContent;
    }
    function showResults(q) {
      cardsEl.hidden = true; mfaqEl.hidden = true; sectionsEl.hidden = true;
      resultsEl.hidden = false; resultsEl.innerHTML = '';
      var matches = model.all.filter(function (r) { return r.searchText.indexOf(q) >= 0; });
      if (!matches.length) {
        resultsEl.innerHTML = '<p class="faq2__status">No results — try different words, or <a href="' + escapeAttr(contactUrl) + '">contact us</a>.</p>';
        return;
      }
      var heading = el('p', 'faq2__results-count');
      heading.textContent = matches.length + (matches.length === 1 ? ' result' : ' results');
      resultsEl.appendChild(heading);
      matches.forEach(function (r) {
        var acc = accordion(r.question, r.answerHtml);
        var tag = el('span', 'faq2-result__cat');
        tag.textContent = r.category.replace(/^\s*\d+\.\s*/, '');
        acc.querySelector('summary').appendChild(tag);
        resultsEl.appendChild(acc);
      });
    }

    var timer;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var q = input.value.trim().toLowerCase();
        if (q) showResults(q); else showBrowse();
      }, 150);
    });
  }

  /* ---------------- fetch + init ---------------- */
  function fail(root) {
    var s = root.querySelector('[data-faq-status]');
    if (s) { s.innerHTML = "We couldn't load the FAQs right now. Please <a href=\"mailto:support@shwink.com.au\">email us</a> or try again shortly."; s.hidden = false; }
  }
  function finishStates(root) {
    var s = root.querySelector('[data-faq-status]');
    if (s) s.hidden = true;
  }

  function init(root) {
    var url = (root.getAttribute('data-faq-url') || '').trim();
    if (!url) {
      var s = root.querySelector('[data-faq-status]');
      if (s) s.textContent = 'Add your published Google Sheet CSV URL in this section’s settings.';
      return;
    }
    if (typeof Papa === 'undefined') { fail(root); console.error('[faq-loader] PapaParse not loaded'); return; }

    var bust = 't=' + Math.floor(Date.now() / 60000);
    var fetchUrl = url + (url.indexOf('?') >= 0 ? '&' : '?') + bust;

    fetch(fetchUrl, { credentials: 'omit' })
      .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.text(); })
      .then(function (text) {
        var parsed = Papa.parse(text, { header: true, skipEmptyLines: true });
        var rows = parsed.data || [];
        if (!rows.length) {
          var s = root.querySelector('[data-faq-status]');
          if (s) { s.textContent = 'FAQs coming soon.'; }
          return;
        }
        var model = buildModel(rows);
        if (!model.all.length) {
          var s2 = root.querySelector('[data-faq-status]');
          if (s2) s2.textContent = 'FAQs coming soon.';
          return;
        }
        finishStates(root);
        render(root, model);
        var input = document.querySelector('[data-faq-search]');
        wireSearch(root, model, input);
      })
      .catch(function (err) { fail(root); console.error('[faq-loader] failed to load FAQ CSV:', err); });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-faq-loader]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
